// extracted by mini-css-extract-plugin
export default {"modal":"index_modal__8GX4M","root":"index_root__ywSW8"};